import useSWR from 'swr';
import { getOffer } from './api';
import { toApiError } from './errors';
import { ILoanOffer } from './types';

/** The offer, only while there is one to show (ELIGIBLE, OFFER_PRESENTED) or one was accepted. */
export const useOffer = (enabled: boolean) => {
  const { data, error, isLoading, mutate } = useSWR<ILoanOffer>(enabled ? 'lending-offer' : null, getOffer, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });
  return {
    offer: data,
    error: error ? toApiError(error) : null,
    isLoading,
    setOffer: (offer: ILoanOffer) => mutate(offer, { revalidate: false }),
  };
};
